import { FunctionComponent, Fragment } from 'react';
import { useGlobalState } from '../../../common/context/AppContext';
import { IAppProps } from '../../../common/interface/IAppProvider';

export const ProgressBar: FunctionComponent<IAppProps> = (props): JSX.Element => {
    const common = props.config.resourceBundles['dk.onsa-common'].read();
    const { actualStep } = useGlobalState();

    const getCurrentStepClass = (step: number) => {
        if (actualStep === step) {
            return ' active';
        } else {
            return actualStep > step - 2 ? ' semi' : ' dimmed';
        }
    };
    if (actualStep < 9 || actualStep > 14) {
        return <Fragment></Fragment>;
    } else {
        return (
            <Fragment>
                <div className={`progress-payment-bar-inner payment-step-${actualStep}`}>
                    <InsuranceInformation step={actualStep} label={common['checkout.icon.label.1']} />
                    <Basket
                        step={actualStep}
                        label={common['checkout.icon.label.2']}
                        className={getCurrentStepClass(9)}
                    />
                    <Injuries
                        step={actualStep}
                        label={common['checkout.icon.label.skader']}
                        className={getCurrentStepClass(10)}
                    />
                    <StartDate
                        step={actualStep}
                        label={common['checkout.icon.label.3']}
                        className={getCurrentStepClass(11)}
                    />
                    <AboutYou
                        step={actualStep}
                        label={common['checkout.icon.label.4']}
                        className={getCurrentStepClass(12)}
                    />
                    <Payment
                        step={actualStep}
                        label={common['checkout.icon.label.5']}
                        className={getCurrentStepClass(13)}
                    />
                    <Accept
                        step={actualStep}
                        label={common['checkout.icon.label.6']}
                        className={actualStep === 14 ? ' active' : ' dimmed'}
                    />
                </div>
            </Fragment>
        );
    }
};

// Icons for the progress bar
const InsuranceInformation = ({ label }: any): any => {
    return (
        <div className="insurance-info-wrapper semi">
            <flos-icon class="flos-icon icon-factory" shape="factory" size="46" style={{ left: 1010, top: -50 }} />
            <div>{label}</div>
        </div>
    );
};

const Basket = ({ label, className }: any): any => {
    return (
        <div className={`basket-wrapper${className}`}>
            <flos-icon class="flos-icon icon-basket" shape="basket" size="50" style={{ left: 1010, top: -50 }} />
            <div>{label}</div>
        </div>
    );
};

const StartDate = ({ label, className }: any): any => {
    return (
        <div className={`contacts-wrapper${className}`}>
            <flos-icon class="flos-icon icon-contacts" shape="contacts" size="71" style={{ left: 1010, top: -50 }} />
            <div>{label}</div>
        </div>
    );
};

const AboutYou = ({ label, className }: any): any => {
    return (
        <div className={`calendar-wrapper${className}`}>
            <flos-icon class="flos-icon icon-calendar" shape="calendar" size="71" style={{ left: 1010, top: -50 }} />
            <div>{label}</div>
        </div>
    );
};

const Payment = ({ label, className }: any): any => {
    return (
        <div className={`payment-wrapper${className}`}>
            <flos-icon
                class="flos-icon icon-credit-cards"
                shape="credit-cards"
                size="71"
                style={{ left: 1010, top: -50 }}
            />
            <div>{label}</div>
        </div>
    );
};

const Accept = ({ label, className }: any): any => {
    return (
        <div className={`accept-wrapper${className}`}>
            <flos-icon
                class="flos-icon icon-document-sign"
                shape="document-sign"
                size="71"
                style={{ left: 1010, top: -50 }}
            />
            <div>{label}</div>
        </div>
    );
};

const Injuries = ({ label, className }: any): any => {
    return (
        <div className={`accept-wrapper${className}`}>
            <flos-icon class="flos-icon icon-injury" shape="band-aid" size="71" style={{ left: 1010, top: -50 }} />
            <div>{label}</div>
        </div>
    );
};
